// extracted by mini-css-extract-plugin
export default {"phone":"styles_phone__EGw-5","phone__btn":"styles_phone__btn__iV5Eo"};